// Datos y funciones de la hoja impresa de códigos (Peaje U-02). Van aparte
// del componente para que la recarga en caliente de Vite funcione.
export const ID_HOJA = 'hoja-codigos';

export const CSS_HOJA = `
@media print {
  body * { visibility: hidden !important; }
  #${ID_HOJA}, #${ID_HOJA} * { visibility: visible !important; }
  #${ID_HOJA} { display: block !important; position: fixed; inset: 0; z-index: 2147483647; background: #fff; color: #000; padding: 2cm; font-family: system-ui, sans-serif; }
  #${ID_HOJA} h1 { font-size: 18pt; margin: 0 0 6pt; }
  #${ID_HOJA} p { font-size: 11pt; margin: 0 0 4pt; }
  #${ID_HOJA} ol { display: grid; grid-template-columns: 1fr 1fr; gap: 8pt 24pt; margin: 14pt 0 0; padding: 0; list-style: none; }
  #${ID_HOJA} li { font-family: ui-monospace, monospace; font-size: 14pt; letter-spacing: 0.05em; }
}
`;

/** Fecha corta en español de México, la del día en que se imprime. */
export function fechaDeHoja(fecha = new Date()) {
  return fecha.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function imprimirHoja() {
  globalThis.window?.print?.();
}
